import { render, staticRenderFns } from "./ViewLiveFeed.vue?vue&type=template&id=bdc4efe4&scoped=true"
import script from "./ViewLiveFeed.vue?vue&type=script&lang=js"
export * from "./ViewLiveFeed.vue?vue&type=script&lang=js"
import style0 from "./ViewLiveFeed.vue?vue&type=style&index=0&id=bdc4efe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc4efe4",
  null
  
)

export default component.exports